// extracted by mini-css-extract-plugin
export default {"container":"shortlist_creator-module___container___ca0be669","addedBy":"shortlist_creator-module___addedBy___ff8d2ab8","link":"shortlist_creator-module___link___d50866b8"};